import React from "react";
import {
  MenuItem,
  StandardTextFieldProps,
  ListItemIcon,
  Stack,
  Typography,
} from "@mui/material";
import TextField from "./TextField";
import { OptionInterface } from "../CommonInterfaces";
import { makeStyles } from "@mui/styles";

interface selectInputInterface extends OptionInterface {
  hasHelperText?: string;
}
const useStyles = makeStyles({
  menuPaper: {
    maxHeight: "200px !important",
  },
});

export interface SelectTextInputInterface extends StandardTextFieldProps {
  value?: string;
  placeholder?: string;
  icon?: string;
  id?: string;
  isWidthLess?: boolean;
  minWidth?: number | string;
  options: selectInputInterface[];
  label?: string;
}

const Select = ({
  value = "",
  placeholder,
  icon,
  isWidthLess,
  id,
  options,
  minWidth,
  label,
  ...props
}: SelectTextInputInterface) => {
  const classes = useStyles();
  return (
    <Stack spacing={0.5} minWidth={isWidthLess ? "100%" : minWidth}>
      <Typography>{label}</Typography>
      <TextField
        select
        value={value}
        {...props}
        id={id}
        SelectProps={{
          displayEmpty: true,
          MenuProps: {
            classes: {
              paper: classes.menuPaper,
            },
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "left",
            },
          },
        }}
        sx={{
          minWidth: isWidthLess ? "100%" : minWidth,
        }}
      >
        {placeholder && placeholder !== "" ? (
          <MenuItem value="">{placeholder}</MenuItem>
        ) : null}
        {options.map((option) => (
          <MenuItem value={option.value}>
            {option.icon && (
              <ListItemIcon>
                <i className="far fa-folder-open" />
              </ListItemIcon>
            )}
            {option.label}
          </MenuItem>
        ))}
      </TextField>
    </Stack>
  );
};

export default Select;
